import { computed } from "vue";

// On phones the search-page filter column is a full-screen sheet. The state
// lives in useState so the toggle button in the results header, the close
// button inside the panel, and the page that decides when a search has started
// all read the same flag without prop drilling through Filters.vue. The
// layout closes it on every route change (layouts/default.vue), so a page
// that unmounts mid-transition can never leave it open over the next page.
export function useFiltersSheet() {
	const open = useState<boolean>("filters-sheet-open", () => false);
	const count = useState<number>("filters-sheet-count", () => 0);

	function toggle() {
		open.value = !open.value;
	}

	function close() {
		open.value = false;
	}

	function show() {
		open.value = true;
	}

	return {
		open,
		count,
		isOpen: computed(() => open.value),
		toggle,
		close,
		show,
	};
}
